export default "__VITE_ASSET__DZuaNRuv__"